module.exports = "<spinner color=\"'white'\" ng-hide=\"usersMsTeamsTabCtrl.consentButton\"></spinner>\n<button class=\"btn btn-primary block full-width m-b\" ng-click=\"usersMsTeamsTabCtrl.openPopup()\" ng-show=\"usersMsTeamsTabCtrl.consentButton\">\n  Click here and consent permissions to continue\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/users/account/msTeamsTab/template.html
// module id = 1033
// module chunks = 0